import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import { applicationNotesRoute } from '@features/applicationNotes';
import { applicationNotesKey } from '@features/applicationNotes/constants';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseApplicationNotesProps = {
  applicationId: number;
  companyId: number;
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useGetEnterpriseApplicationNotes = ({
  applicationId,
  companyId,
  setErrorText,
}: useGetEnterpriseApplicationNotesProps) => {
  const {
    data: enterpriseApplicationNotesData,
    isLoading: isLoadingEnterpriseApplicationNotesData,
  } = useQuery({
    queryKey: [applicationNotesKey, applicationId, companyId],
    queryFn: () =>
      axiosInstance
        .get(applicationNotesRoute, {
          params: { application_id: applicationId, company_id: companyId },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.length) {
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });
  return { enterpriseApplicationNotesData, isLoadingEnterpriseApplicationNotesData };
};
